export type EmployeeHospitalEntry = {
  hospital_id?: number;
  name: string;
  is_primary?: boolean;
};

type EmployeeHospitalsSource = {
  hospital?: string | null;
  hospitals?: EmployeeHospitalEntry[] | null;
};

/** Liste des hôpitaux affectés (réseau), avec repli sur le champ legacy unique. */
export function getEmployeeHospitalEntries(
  employee: EmployeeHospitalsSource,
): EmployeeHospitalEntry[] {
  const rows = (employee.hospitals ?? []).filter((h) => h.name?.trim());
  if (rows.length > 0) {
    return rows.map((h) => ({
      hospital_id: h.hospital_id,
      name: h.name.trim(),
      is_primary: Boolean(h.is_primary),
    }));
  }
  const legacy = employee.hospital?.trim();
  if (legacy) {
    return [{ name: legacy, is_primary: true }];
  }
  return [];
}

/** Libellé court pour listes / exports (tous les hôpitaux séparés par ·). */
export function formatEmployeeHospitals(employee: EmployeeHospitalsSource): string {
  const entries = getEmployeeHospitalEntries(employee);
  if (entries.length === 0) return "";
  return entries.map((h) => h.name).join(" · ");
}
